<template>
  <modal @close="$emit('close')">
    <template #body>
      <div class="modal-write">
        <div class="modal-write__form">
          <div class="modal-write__title">Обсудить проект</div>
          <div class="modal-write__info">
            Расскажите о задаче — архитектор свяжется с вами в день обращения
          </div>

          <div v-if="success" class="fp-success-screen">
            <div class="fp-success-screen__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="23" stroke="#1B1918" stroke-width="1.5"/>
                <polyline points="14,24 21,31 34,17" fill="none" stroke="#1B1918" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="fp-success-screen__title">Ваш запрос отправлен</h3>
            <p class="fp-success-screen__text">Наш менеджер с Вами свяжется.</p>
            <div class="fp-success-screen__social">
              <p class="fp-success-screen__social-label">Подписывайтесь на нас в соцсетях</p>
              <div class="fp-success-screen__social-links">
                <a href="https://t.me/sharunstore" target="_blank" class="fp-success-screen__social-link">
                  <DefIcon name="tg" />
                </a>
                <a href="https://ru.pinterest.com/sharunstore/" target="_blank" class="fp-success-screen__social-link">
                  <DefIcon name="pnts" />
                </a>
                <a href="https://www.youtube.com/@sharun-store" target="_blank" class="fp-success-screen__social-link">
                  <DefIcon name="youtube" />
                </a>
                <a href="https://dzen.ru/sharunstore" target="_blank" class="fp-success-screen__social-link">
                  <DefIcon name="dzen" />
                </a>
              </div>
            </div>
          </div>

          <form v-else @submit.prevent="send" novalidate>
            <div class="modal-write__inputs-row">
              <Input
                placeholder="Ваше имя"
                type="text"
                class="input input-full"
                v-model="name"
              />
              <Input
                placeholder="Ваш телефон"
                type="text"
                class="input input-full"
                v-model="phone"
              />
            </div>

            <div class="modal-write__input-box">
              <Textarea
                placeholder="Тип объекта, площадь, стиль, особые пожелания"
                class="input input-full"
                v-model="comment"
              />
            </div>

            <div class="modal-write__input-box">
              <label class="fp-file">
                <input
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.pdf,.dwg"
                  class="fp-file__input"
                  @change="onFilePick"
                />
                <span class="fp-file__label">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                    <polyline points="17 8 12 3 7 8"/>
                    <line x1="12" y1="3" x2="12" y2="15"/>
                  </svg>
                  <span v-if="!files.length">Прикрепить файл — эскиз, ТЗ, референсы</span>
                  <span v-else>{{ files.map(f => f.name).join(', ') }}</span>
                </span>
              </label>
              <p class="fp-file__hint">JPG, PNG, PDF, DWG — до 20 МБ каждый</p>
            </div>

            <button
              type="submit"
              class="full-dark-btn fp-submit"
              :disabled="!agreed"
            >Отправить запрос</button>

            <Checkbox
              label="Я соглашаюсь с <a href='/privacy'>политикой конфиденциальности</a>"
              :isCheck="agreed"
              name="agreement_politic"
              @change="agreed = $event"
            />

            <p v-if="error" class="fp-error">{{ error }}</p>
          </form>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import modal from '~/components/UI/Modal.vue'
import Input from '~/components/UI/inputs/Input.vue'
import Textarea from '~/components/UI/inputs/Textarea.vue'
import Checkbox from '~/components/UI/btn/Checkbox.vue'
import DefIcon from '~/components/UI/Icons/DefIcon.vue'
import api from '~/api/api.js'

defineEmits(['close'])

const name    = ref('')
const phone   = ref('')
const comment = ref('')
const files   = ref([])
const agreed  = ref(false)
const success = ref(false)
const error   = ref('')

function onFilePick(e) {
  files.value = Array.from(e.target.files || []).slice(0, 10)
}

async function send() {
  error.value = ''
  if (!name.value || !phone.value) {
    error.value = 'Заполните имя и телефон.'
    return
  }
  if (!agreed.value) {
    error.value = 'Подтвердите согласие.'
    return
  }

  const fd = new FormData()
  fd.append('product_id', '42')
  fd.append('name', name.value)
  fd.append('phone', phone.value)
  if (comment.value) fd.append('comment', comment.value)
  files.value.forEach(f => fd.append('files[]', f))

  try {
    await api('/order', fd, 'POST')
    success.value = true
    name.value  = ''
    phone.value = ''
    comment.value = ''
    files.value = []
  } catch {
    error.value = 'Произошла ошибка. Попробуйте ещё раз.'
  }
}
</script>

<style scoped lang="scss">
.fp-file {
  display: block;
  cursor: pointer;

  &__input {
    display: none;
  }

  &__label {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.4rem 1.6rem;
    border: 1px solid #d8d8d8;
    border-radius: 0.4rem;
    font-size: 1.5rem;
    color: #555;
    background: #fff;
    transition: border-color 0.2s;
    cursor: pointer;

    &:hover {
      border-color: #1B1918;
    }

    svg {
      flex-shrink: 0;
      color: #aaa;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &__hint {
    margin-top: 0.6rem;
    font-size: 1.2rem;
    color: #aaa;
  }
}

.fp-success-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 2rem 2rem;

  &__icon {
    margin-bottom: 2.4rem;
    svg { display: block; }
  }

  &__title {
    font-size: 2.4rem;
    font-weight: 500;
    color: #1B1918;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  &__text {
    font-size: 1.6rem;
    color: #888;
    margin-bottom: 3.2rem;
  }

  &__social {
    width: 100%;
    border-top: 1px solid #f0f0f0;
    padding-top: 2.8rem;
  }

  &__social-label {
    font-size: 1.4rem;
    color: #aaa;
    margin-bottom: 2rem;
    letter-spacing: 0.02em;
  }

  &__social-links {
    display: flex;
    justify-content: center;
    gap: 2.4rem;
  }

  &__social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.8rem;
    height: 4.8rem;
    border: 1px solid #e8e8e8;
    border-radius: 50%;
    color: #1B1918;
    transition: border-color 0.2s, background 0.2s;

    &:hover {
      border-color: #1B1918;
      background: #1B1918;
      color: #fff;
    }

    svg { width: 2rem; height: 2rem; }
  }
}

.fp-error {
  margin-top: 1.2rem;
  font-size: 1.4rem;
  color: #c62828;
}
</style>
